import { type ReactQuery } from 'cms-api'
import React from 'react'
import { Box, Grid } from 'components/Layout'
import { SPACE } from 'Theme'
import { ExpertTeamMemberInviteWidget } from '../ExpertTeamMemberInviteWidget'
import { ExpertFavoritesWidget } from './ExpertFavoritesWidget'
import { HighlightsWidget } from './HighlightsWidget'
import { RecentOrdersWidget } from './RecentOrdersWidget'
import { StatusLifecycleWidget } from './StatusLifecycleWidget'
import { TeamWidget } from './TeamWidget'
import { TierJourneyWidget } from './TierJourneyWidget'
import { TradePerksWidget } from './TradePerksWidget'

type TradeTabContentProps = {
  isLoading?: boolean
  data?: ReactQuery.ExpertDashboardTradeTierResponse
}

export const TradeTabContent = ({ isLoading, data }: TradeTabContentProps) => (
  <>
    <Box mb={SPACE.PX_20}>
      <TierJourneyWidget
        isLoading={isLoading}
        currentTier={data?.currentTier}
        currentYearSpend={data?.currentYearSpend ?? 0}
        spendToNextTier={data?.spendToNextTier}
      />
    </Box>
    <Box mb={SPACE.PX_20}>
      <StatusLifecycleWidget
        isLoading={isLoading}
        currentTier={data?.currentTier}
        currentYearSpend={data?.currentYearSpend ?? 0}
        spendToNextTier={data?.spendToNextTier}
      />
    </Box>

    <Grid
      gridTemplateColumns={{ MOBILE: '1fr', TV: '1.4fr 1fr' }}
      gridTemplateRows="auto"
      gridGap={SPACE.PX_20}
      mb={SPACE.PX_20}
    >
      <TradePerksWidget isLoading={isLoading} currentTier={data?.currentTier} />
      <TeamWidget />
    </Grid>

    <Box mb={SPACE.PX_20}>
      <ExpertFavoritesWidget />
    </Box>

    <HighlightsWidget />

    <RecentOrdersWidget />

    <Grid
      gridTemplateColumns={{ MOBILE: '1fr', DESKTOP: '1fr 1fr' }}
      gridTemplateRows="auto"
      gridGap={SPACE.PX_20}
      mt={SPACE.PX_20}
    >
      <ExpertTeamMemberInviteWidget />
    </Grid>
  </>
)
